import React from 'react';
import bem from 'utils/bem.js';
import face from './img/face.svg';

const { cnBlock } = bem('video-placeholder--client');
export const ClientPlaceholder = ({className}) => {
    return (
        <div className={ cnBlock(className) }>
            <img src={face} />
        </div>
    )
}
